export type ErrorTestComponentProps = {
  data: unknown
}

export function ErrorTestComponent(_props: ErrorTestComponentProps): React.ReactElement {
  return <div></div>
}
